import type {
  HealthProfileMedicationToVerifyWithSearch,
  HealthProfileMedicationTransferrable,
  MedicationTransferCandidateResult,
} from '../data/healthProfile';
import { usePersistentData } from '../usePersistentData';

const HEALTH_PROFILE_CONTEXT_KEY = 'HEALTH_PROFILE_CONTEXT_KEY';
const V1 = 'V1';
const V2 = 'V2';

export interface HealthProfileData {
  selectedMeds: MedicationTransferCandidateResult[];
  otherMeds: string;
  medsToTransfer: MedicationTransferCandidateResult[];
  lastVisit?: Date;
}
export const emptyHealthProfileData = { selectedMeds: [], otherMeds: '', medsToTransfer: [], lastVisit: undefined };

export function useHealthProfilePersistentData() {
  const { data, setData, isLoading } = usePersistentData(`${HEALTH_PROFILE_CONTEXT_KEY}.${V1}`);
  let dataObj = data ? (JSON.parse(data) as HealthProfileData) : emptyHealthProfileData;
  const setHealthProfilePersistentData = (newContext: HealthProfileData) => {
    setData(newContext);
    dataObj = newContext;
  };

  return {
    healthProfilePersistentData: dataObj,
    setHealthProfilePersistentData,
    isLoadingPersistentData: isLoading,
  };
}

export interface HealthProfileDataV2 {
  selectedMeds: HealthProfileMedicationToVerifyWithSearch[];
  otherMeds: string;
  medsToTransfer: HealthProfileMedicationTransferrable[];
  lastVisit?: Date;
}

export function useHealthProfileV2PersistentData() {
  const { data, setData, isLoading } = usePersistentData(`${HEALTH_PROFILE_CONTEXT_KEY}.${V2}`);
  let dataObj = data ? (JSON.parse(data) as HealthProfileDataV2) : emptyHealthProfileData;
  const setHealthProfilePersistentData = async (newContext: HealthProfileDataV2) => {
    await setData(newContext);
    dataObj = newContext;
  };

  return {
    healthProfilePersistentData: dataObj,
    setHealthProfilePersistentData,
    isLoadingPersistentData: isLoading,
  };
}
